import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

import { type Assessment } from '../entities/KYC'

export async function fetchPendingUserAssessments() {
  return await httpClientBanking<{ data: Assessment[] }>({
    url: 'me/assessments/pending/users',
    method: 'GET'
  })
}

export function usePendingUserAssessments(options: { enabled?: boolean } = {}) {
  const { data, ...rest } = useQueryRequest<{ data: Assessment[] }>(
    ['pendingUserAssessments'],
    () => fetchPendingUserAssessments(),
    options
  )

  return { assessments: data?.data?.data ?? [], ...rest }
}
